/* eslint-disable no-restricted-globals */
import { GeneralSearchInput } from "../../param/generalSearchInput";
import { ListDefinition } from "../../param/listDefinitionType";
import { frypanDictionary } from "../data/frypan";
import { dataSource } from "../dictionaryWorker";
import { workerStatus } from "../worker";
import { progress, sendProgress } from "./generalSearchProgress";
import { Result, Trace } from "./generalSearchResult";
import { generalSearchFuncTable } from "./search/generalSearchFunctions";

const queryFunc = async (
  query: any,
  input: GeneralSearchInput,
  words: string[],
  listDefinitionsTable: Record<string, ListDefinition>,
  result: Result,
  workerContext: any
) => {
  if (workerStatus.abort) {
    return result;
  }
  progress.get().queryProgress.push({
    totalWordCount: result.length,
    currentWordCount: 0,
    startTime: Date.now(),
  });
  await sendProgress(workerContext);

  result = await generalSearchFuncTable[query.type]({
    query,
    input,
    words,
    listDefinitionsTable,
    result,
    workerContext,
  });

  const resultList = new Set<string>();
  result.forEach((e) => {
    resultList.add(JSON.stringify(e.trace));
  });
  result = Array.from(resultList).map((e) => {
    const ret = {
      trace: JSON.parse(e),
      currentWord: "",
    };
    ret.currentWord = ret.trace[ret.trace.length - 1];
    return ret;
  });

  if (!workerStatus.abort) {
    const lastQueryProgress =
      progress.get().queryProgress[progress.get().queryProgress.length - 1];
    lastQueryProgress.currentWordCount = lastQueryProgress.totalWordCount;
    lastQueryProgress.endTime = Date.now();
  }
  await sendProgress(workerContext, true);
  return result;
};

export const onGeneralSearch = async (
  workerContext: any,
  input: GeneralSearchInput
) => {
  let words =
    input.inputDictionary === "free"
      ? input.inputDictionaryFree.split("\n")
      : input.inputDictionary === "frypan"
        ? frypanDictionary
        : Array.isArray(input.inputDictionary)
          ? dataSource.getArray(input.inputDictionary)
          : dataSource.get(input.inputDictionary);

  if (!words) {
    return [];
  }

  progress.set({
    startTime: Date.now(),
    currentTime: Date.now(),
    queryProgress: [],
  });
  await sendProgress(workerContext);

  let result: Result = words.map((word) => {
    return {
      trace: [] as Trace[],
      currentWord: word,
    };
  });

  const listDefinitionsTable = input.listDefinitions.reduce(
    (table, listDefinition) => {
      listDefinition.name.split(/\s*[\|/:]\s*/g).forEach((name) => {
        table[name] = listDefinition;
      });
      return table;
    },
    {} as Record<string, ListDefinition>
  );

  result.forEach((e) => {
    e.trace.push(e.currentWord);
  });

  for (const query of input.queries) {
    if (!(query.enabled ?? true)) {
      continue;
    }
    if (query.type === "sequence") {
      for (const process of query.processes) {
        result = await queryFunc(
          process,
          input,
          words,
          listDefinitionsTable,
          result,
          workerContext
        );
      }
    } else {
      result = await queryFunc(
        query,
        input,
        words,
        listDefinitionsTable,
        result,
        workerContext
      );
    }
  }

  const ret = result.map((e) => e.trace.join(",")).sort();
  await sendProgress(workerContext, true);
  return { result: ret, progress: progress.get() };
};
